import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/triggerJob';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// "Run now": trigger a sync job. The pre-saga component ignored trigger
// errors entirely, so failures stay silent (no global error dispatch).
function* operation(action) {
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/jobs/${action.payload.jobId}/trigger`,
      {},
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(res.data?.data || res.data));
  } catch (error) {
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
